import "../assets/css/About.css";
import { useEffect, useRef, useState } from "react";
import Team from "../assets/img/About_Us/Corporate Meeting Insight.jpg";
import HeroBg from "../assets/img/About_Us/about-hero-bg.jpg";
import Profile_pic2 from "../assets/img/About_Us/profile-pic1.png";
import Profile_pic3 from "../assets/img/About_Us/profile-pic12.png";
import why_choose_us from "../assets/img/About_Us/why-choose-us.jpg";

//ICONS
import industry_icon from "../assets/icons/industry-icon.png";
import graduation_icon from "../assets/icons/graduation-icon.png";
import innovation_icon from "../assets/icons/innovation.png";
import excellence_icon from "../assets/icons/excellence.png";
import integrity_icon from "../assets/icons/integrity.png";
import growth_icon from "../assets/icons/growth.png";
import thropy_icon from "../assets/icons/thropy-icon.png";
import deep_industry_tree from "../assets/icons/deep-industry-root.png";
import medal_icon from "../assets/icons/medal_2955931.png";
import right_icon from "../assets/icons/check_9109805.png";
import star_icon from "../assets/icons/star-icon.png";
import placement_icon from "../assets/icons/palcement-icon.png";
import hands_on from "../assets/icons/hands-on-uproach.png";
import headquartes_icon from "../assets/icons/factory_11248062.png";
import delivery_icon from "../assets/icons/delivery_8830041.png";

import { Helmet } from "react-helmet";
import data from "../../src/component/ApiUrl/meta_api";
import { useNavigate } from "react-router-dom";

// ─── Data ────────────────────────────────────────────────────

const heroStats = [
  { num: "200+", label: "Businesses & Industries Served" },
  { num: "2500+", label: "Students & Professionals Trained" },
  { num: "5+", label: "Years of Industry Excellence" },
  { num: "100+", label: "Corporate Training Batches Delivered" },
];

const identityCards = [
  {
    icon: industry_icon,
    title: "Industry Services Partner",
    desc: "Technology partner delivering automation, embedded systems, software, and digital marketing solutions across India.",
  },
  {
    icon: graduation_icon,
    title: "Professional Training Hub",
    desc: "Industry-aligned certification courses, internships, workshops, and corporate training programs for students and professionals.",
  },
];

const values = [
  {
    icon: innovation_icon,
    title: "Innovation",
    desc: "Constantly pushing boundaries embracing new technologies and creative thinking in everything we do for clients and learners.",
  },
  {
    icon: excellence_icon,
    title: "Excellence",
    desc: "Holding ourselves to the highest standards in every project we deliver and every training program we run.",
    featured: true,
  },
  {
    icon: integrity_icon,
    title: "Integrity",
    desc: "Building lasting relationships through transparency, honesty, and always doing what's right for our clients and students.",
  },
  {
    icon: growth_icon,
    title: "Growth",
    desc: "Believing in continuous growth for our clients' businesses, our students' careers, and our own team members every day.",
  },
  {
    icon: graduation_icon,
    title: "Collaboration",
    desc: "Working as true partners deeply understanding your goals and aligning our expertise to help you achieve them together.",
    featured: true,
  },
  {
    icon: thropy_icon,
    title: "Impact",
    desc: "Every solution we build and every skill we teach is aimed at creating real, measurable, and lasting impact for people and businesses.",
  },
];

const servicePartners = [
  {
    image: require("../assets/img/About_Us/logo/logo-1.jpg"),
    name: "BriX",
  },
  {
    image: require("../assets/img/About_Us/logo/logo-2.jpg"),
    name: "AMS Brand",
  },
  {
    image: require("../assets/img/About_Us/logo/logo-3.jpg"),
    name: "ATS",
  },
  {
    image: require("../assets/img/About_Us/logo/logo-4.jpg"),
    name: "QD Creation",
  },
  {
    image: require("../assets/img/About_Us/logo/logo-5.jpg"),
    name: "Teksii Solutions",
  },
  {
    image: require("../assets/img/About_Us/logo/logo-6.jpg"),
    name: "In Tech",
  },
];

const team = [
  {
    initials: Profile_pic3,
    name: "Managing Director",
    role: "Founder & CEO",
    desc: "Visionary leader with 5+ years of expertise in industrial automation and engineering driving Skimitar's strategic direction and growth across India.",
    avatarStyle: { background: "#FCEBEB", color: "#A32D2D" },
  },
  {
    initials: Profile_pic2,
    name: "Technical Head",
    role: "Head of Engineering Services",
    desc: "Seasoned automation engineer overseeing all technical projects ensuring precision, quality, and innovation in every solution delivered to clients.",
    avatarStyle: { background: "#E6F1FB", color: "#0C447C" },
  },
  {
    initials: Profile_pic3,
    name: "Training Director",
    role: "Head of Training & Development",
    desc: "Industry professional with a passion for education designing and delivering curriculum that bridges the gap between academics and real industry demands.",
    avatarStyle: { background: "#E1F5EE", color: "#085041" },
  },
  {
    initials: Profile_pic2,
    name: "Digital Marketing Head",
    role: "Head of Digital Strategy",
    desc: "Digital marketing strategist leading brand growth, online campaigns, and client acquisition across all digital platforms for Skimitar and its clients.",
    avatarStyle: { background: "#EEEDFE", color: "#3C3489" },
  },
];

const whyCards = [
  {
    icon: industry_icon,
    title: "Dual Expertise",
    desc: "Unique combination of industry services and professional training all under one trusted brand with 5+ years of experience.",
  },
  {
    icon: deep_industry_tree,
    title: "Deep Industry Roots",
    desc: "Hands-on expertise across automation, IT, embedded systems & digital marketing serving 20+ industry sectors pan-India.",
  },
  {
    icon: graduation_icon,
    title: "Industry-Aligned Curriculum",
    desc: "Training programs continuously updated with real industry requirements not just textbook content.",
  },
  {
    icon: hands_on,
    title: "Hands-On Approach",
    desc: "Every project and every training session is built around practical, real-world application learn by doing.",
  },
  {
    icon: integrity_icon,
    title: "Pan-India Reach",
    desc: "Serving clients and training professionals across multiple Indian states online and on-site with consistent quality.",
  },
  {
    icon: placement_icon,
    title: "Placement & Career Support",
    desc: "Dedicated career services resume building, mock interviews, job referrals, and career counselling for every learner.",
  },
];

const certs = [
  {
    icon: medal_icon,
    title: "ISO 9001:2015 Certified",
    desc: "Internationally recognised quality management certification ensuring consistent, high-quality service delivery.",
  },
  {
    icon: right_icon,
    title: "NSDC Affiliated",
    desc: "Approved training partner under National Skill Development Corporation validating our training standards.",
  },
  {
    icon: graduation_icon,
    title: "Industry-Certified Courses",
    desc: "All training programs aligned with industry certification standards recognized by top employers.",
  },
  {
    icon: industry_icon,
    title: "Authorised Brand Partner",
    desc: "Official authorised partner of Mitsubishi, Siemens, Delta, Omron, Rockwell & ABB.",
  },
  {
    icon: thropy_icon,
    title: "Best Training Institute 2023",
    desc: "Awarded for excellence in professional training and skill development in the region.",
  },
  {
    icon: star_icon,
    title: "4.8/5 Student Rating",
    desc: "Consistently high ratings from 2500+ trained students across all batches and programs.",
  },
];

const presence = [
  {
    icon: headquartes_icon,
    iconBg: "#FCEBEB",
    title: "Headquarters & Training Centre",
    desc: "Our main office and training centre in Erode, Tamil Nadu equipped with labs, live equipment, and expert faculty for hands-on learning.",
  },
  {
    icon: excellence_icon,
    iconBg: "#E6F1FB",
    title: "Online Training Platform",
    desc: "Live online training accessible from anywhere in India with recorded sessions, assignments, and dedicated online mentorship support.",
  },
  {
    icon: delivery_icon,
    iconBg: "#E1F5EE",
    title: "Pan-India Service Delivery",
    desc: "On-site project delivery and technical services across Tamil Nadu, Karnataka, Andhra Pradesh, Maharashtra, Kerala & beyond.",
  },
  {
    icon: integrity_icon,
    iconBg: "#FAEEDA",
    title: "Corporate On-Site Training",
    desc: "We travel to your facility and deliver customized corporate training programs zero disruption to your business operations.",
  },
];

// ─── SEQUENTIAL ANIMATION HOOK ───────────────────────────────
function useSequentialReveal(
  sectionRef,
  cardSelector = ".seq-card",
  animDuration = 600,
) {
  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const cards = Array.from(section.querySelectorAll(cardSelector));
    if (!cards.length) return;
    let revealIndex = 0;
    let isAnimating = false;
    cards.forEach((card) => {
      card.classList.add("seq-hidden");
    });
    const revealNext = () => {
      if (revealIndex >= cards.length) return;
      const card = cards[revealIndex];
      card.classList.remove("seq-hidden");
      card.classList.add("seq-visible");
      revealIndex++;
      if (revealIndex < cards.length) {
        setTimeout(revealNext, animDuration + 80);
      } else {
        isAnimating = false;
      }
    };
    const handleHover = (hoveredCard) => {
      const idx = cards.indexOf(hoveredCard);
      for (let i = revealIndex; i <= idx; i++) {
        cards[i].classList.remove("seq-hidden");
        cards[i].classList.add("seq-visible");
      }
      if (idx >= revealIndex) revealIndex = idx + 1;
      if (revealIndex < cards.length && !isAnimating) {
        isAnimating = true;
        setTimeout(revealNext, animDuration + 80);
      }
    };
    cards.forEach((card) => {
      card.addEventListener("mouseenter", () => handleHover(card));
    });
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && revealIndex === 0) {
            isAnimating = true;
            revealNext();
            observer.unobserve(section);
          }
        });
      },
      { threshold: 0.15 },
    );
    observer.observe(section);
    return () => {
      observer.disconnect();
      cards.forEach((card) => {
        card.removeEventListener("mouseenter", () => handleHover(card));
      });
    };
  }, []);
}

function SectionLabel({ text }) {
  return (
    <p
      className="fw-semibold text-uppercase mb-1"
      style={{ fontSize: 20, color: "#cc0000", letterSpacing: 1 }}
    >
      {text}
    </p>
  );
}

// ═══════════════════════════════════════════════════════════════
// HERO
// ═══════════════════════════════════════════════════════════════
function Hero() {
  return (
    <section className="ab-hero-section position-relative overflow-hidden">
      <div className="ab-hero-bg position-absolute w-100 h-100">
        <img
          src={HeroBg}
          className="w-100 h-100"
          style={{ objectFit: "cover" }}
          alt=""
        />
      </div>
      <div
        className="container container_width px-3 position-relative"
        style={{ zIndex: 1 }}
      >
        <span className="ab-hero-badge d-inline-block px-2 py-1 mb-2 mb-md-3 rounded-4">
          About Skimitar Hindusthan
        </span>
        <p className="ab-hero-title fw-bolder mb-2 text-white">
          Driven by <span className="text-primary-red">Innovation.</span>
          <br />
          Defined by <span className="text-primary-red">Excellence.</span>
        </p>
        <p className=" content_text mb-3 mb-md-4 col-12 col-sm-10 col-md-9 col-lg-7 text-white">
          For over 15 years, Skimitar Hindusthan Pvt Ltd has been building a
          legacy of engineering excellence and transforming careers one project
          and one student at a time.
        </p>
        <div className="row g-2 ab-hero-stats-row">
          {heroStats.map((s) => (
            <div key={s.num} className="col-6 col-sm-6 col-lg-3">
              <div className="ab-stat-box rounded-4 border border-light bg-transparent card h-100">
                <div className="card-body p-1 p-md-2 text-center">
                  <span className="ab-stat-num text-white d-block">
                    {s.num}
                  </span>
                  <span className="ab-stat-lbl text-white">{s.label}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── STORY ────────────────────────────────────────────────────
function StorySection() {
  return (
    <section className="margin_top">
      <div className="container container_width">
        <div className="row g-4 g-lg-5">
          <div className="col-lg-6">
            <SectionLabel text="Our Story" />
            <h2 className="fw-semibold mb-3" style={{ fontSize: 20 }}>
              Built on a Vision to Evolve, Innovate & Succeed
            </h2>

            <p className="content_text mb-4">
              <span className="text-danger fw-bold">
                Skimitar Hindusthan Pvt Ltd
              </span>
              , founded in 2009 in Erode, Tamil Nadu, is a technology company
              specializing in industrial automation, embedded systems, IIoT
              solutions, IT & software development, and digital marketing
              services.
            </p>
            <p className="content_text mb-4">
              We also deliver job-oriented training, internships, and corporate
              training programs, empowering students, professionals, and
              businesses with practical skills and industry-ready solutions.
            </p>
            <div className="row g-3 mb-4 mb-5">
              {identityCards.map((c) => (
                <div key={c.title} className="col-12 col-md-6 col-lg-6">
                  <div className=" card h-100 border bg-light-subtle rounded-2 shadow-sm">
                    <div className="card-body p-3">
                      <img
                        src={c.icon}
                        alt={c.title}
                        style={{
                          width: "36px",
                          height: "36px",
                          objectFit: "contain",
                        }}
                        className="d-block mb-2"
                      />
                      <p className="about-text ab-id-title small fw-bold text-uppercase mb-2">
                        {c.title}
                      </p>
                      <p className="content_text about-text small mb-0">
                        {c.desc}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <p className="content_text mb-4">
              Our strength lies in our dual role as an industry partner and
              training provider, delivering technology solutions and practical,
              real-world learning aligned with market requirements.
            </p>
          </div>
          <div className="col-lg-6 d-flex flex-column">
            <div className="ab-vision-box border-start border-4 border-primary-red bg-light-subtle p-4 mt-4 mb-5">
              <span className="small text-uppercase fw-bold text-primary-red">
                Our Vision
              </span>
              <p className="mb-0 mt-2 fst-italic about-text">
                "To be India’s trusted technology and training partner,
                empowering industries to innovate and individuals to excel."
              </p>
            </div>
            <div className="ab-story-img-wrap position-relative mt-4 ms-4 flex-grow-1 d-flex">
              <div
                className="ab-vision-box position-absolute border-start border-top border-4 border-opacity-25"
                style={{
                  top: "-1.5rem",
                  left: "-1.5rem",
                  width: "7rem",
                  height: "7.5rem",
                }}
              ></div>
              <img
                className="img-fluid rounded-1 shadow-lg w-100 h-100 position-relative z-1 rounded-4"
                style={{ objectFit: "cover" }}
                src={require("../assets/img/About_Us/about-img-1.jpg")}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── VALUES ───────────────────────────────────────────────────
function MissionValues() {
  const sectionRef = useRef(null);
  useSequentialReveal(sectionRef, ".val-seq-card", 550);
  return (
    <section className="ab-values-section bg_color " ref={sectionRef}>
      <div className="container margin_top container_width ">
        <div className="mb-5" style={{ paddingTop: "30px" }}>
          <SectionLabel text="Mission & Values" />
          <h2 className="fw-semibold  " style={{ fontSize: 20 }}>
            What Drives Us Every Single Day
          </h2>
        </div>
        <div className="ab-mission-banner border-0 shadow-sm rounded-2 mb-5">
          <div className="card-body bg-white p-4 p-lg-5">
            <span className="small text-uppercase ab-val-title fw-bold text-primary-red">
              Our Mission
            </span>
            <p className="content_text lead about-text mb-0 mt-2">
              To deliver innovative, reliable, and results-driven technology
              solutions to businesses while equipping the next generation of
              professionals with industry-relevant skills that create lasting
              impact, sustainable careers, and measurable growth.
            </p>
          </div>
        </div>
        <div className="row g-4">
          {values.map((v) => (
            <div
              key={v.title}
              className={`col-md-4 col-sm-6 col-lg-2 val-seq-card seq-card ${v.featured ? "d-flex align-items-stretch" : ""}`}
              style={{ paddingBottom: "30px" }}
            >
              <div className="ab-val-card card h-100 border-0 shadow rounded-0 w-100">
                <div className="card-body d-flex flex-column justify-content-center align-items-center">
                  <img
                    src={v.icon}
                    alt={v.title}
                    style={{
                      width: "48px",
                      height: "48px",
                      objectFit: "contain",
                    }}
                    className="d-block mb-3"
                  />
                  <p className="ab-val-title fw-semibold text-uppercase">
                    {v.title}
                  </p>
                  {/* <p className="content_text about-text small mb-0">{v.desc}</p> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function TeamSection() {
  return (
    <section className="ab-team-section margin_top">
      <div className="container container_width">
        <div className="mb-5">
          <SectionLabel text="Our Team" />
          <h2 className="fw-semibold mb-3" style={{ fontSize: 20 }}>
            The Experts Behind Every Success
          </h2>

          <p className="content_text lead about-text mt-3 col-lg-8">
            Our leadership team brings together decades of industry experience
            across automation, technology, and education united by a shared
            passion for innovation and excellence.
          </p>
        </div>
        <div className="row align-items-stretch">
          <div className="col-12 col-md-6 d-flex flex-column">
            {team.map((m) => (
              <div key={m.name} className="mt-4 flex-grow-1">
                <div className="ab-team-card card h-100 border-0 shadow-sm rounded-0">
                  <div className="card-body p-3 d-flex flex-column">
                    <div className="d-flex align-items-start gap-3">
                      <div
                        className="ab-team-avatar d-flex align-items-center justify-content-center rounded-5"
                        style={{
                          ...m.avatarStyle,
                          width: "60px",
                          height: "60px",
                        }}
                      >
                        <img
                          src={m.initials}
                          alt="profile"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "50%",
                          }}
                        />
                      </div>
                      <div className="flex-grow-1">
                        <h4 className="h6 team-name fw-bold mb-1">{m.name}</h4>
                        <p className="small team-role text-primary-red mb-0">
                          {m.role}
                        </p>
                      </div>
                    </div>
                    <p className="content_text mt-3 mb-0">{m.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="col-12 col-md-6 d-flex">
            <div className="team-img-wrapper">
              <img src={Team} alt="team" />
            </div>
          </div>
        </div>
        <div className="ab-team-note border mt-5 text-center">
          <div className="card-body py-3">
            <span className="content_text fw-semibold about-text">
              Backed by 50+ engineers, trainers, developers & marketing
              professionals dedicated to your success.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}

// ═══════════════════════════════════════════════════════════════
// WHY CHOOSE US EXACT VIDEO STYLE
// Left: accordion list (icon + title + animated underline + desc)
// Right: sticky image with corner accents
// ═══════════════════════════════════════════════════════════════
function WhyUs() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.12 },
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="ab-why-section margin_top bg_color" ref={sectionRef}>
      <div
        className="container container_width "
        style={{ paddingTop: "30px", paddingBottom: "30px" }}
      >
        {/* Header */}
        <div
          className="mb-5"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(28px)",
            transition: "opacity 0.6s ease, transform 0.6s ease",
          }}
        >
          <SectionLabel text="Why Choose Us" />
          <h2 className="fw-semibold mb-3" style={{ fontSize: 20 }}>
            What Truly Sets Skimitar Apart
          </h2>
        </div>

        {/* Main 2-col grid */}
        <div className="ab-why-grid">
          {/* LEFT Accordion */}
          <div
            className="ab-why-img-col"
            style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateX(0)" : "translateX(48px)",
              transition: "opacity 0.7s ease 0.25s, transform 0.7s ease 0.25s",
            }}
          >
            <div className="ab-why-img-frame">
              <img
                src={why_choose_us}
                alt="Why Choose Skimitar"
                className="ab-why-img rounded-4"
              />
            </div>
          </div>

          {/* RIGHT Sticky image */}
          <div className="ab-why-acc-col">
            <ul className="ab-why-list">
              {whyCards.map((w, i) => (
                <li
                  key={w.title}
                  className={[
                    "ab-why-item",
                    isVisible ? "ab-why-item--in" : "",
                    activeIndex === i ? "ab-why-item--active" : "",
                  ]
                    .filter(Boolean)
                    .join(" ")}
                  style={{ transitionDelay: isVisible ? `${i * 85}ms` : "0ms" }}
                  onClick={() => setActiveIndex(i)}
                >
                  {/* Icon + Title + Chevron */}
                  <div className="ab-why-row">
                    <img
                      src={w.icon}
                      alt={w.title}
                      className="ab-why-ico-img"
                    />
                    <span className="ab-why-title-txt">{w.title}</span>
                    <svg
                      className="ab-why-chevron"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                  </div>

                  {/* Animated red underline exact video style */}
                  <div className="ab-why-underline-track">
                    <div className="ab-why-underline-fill" />
                  </div>

                  {/* Expandable description */}
                  <div className="ab-why-body">
                    <p className="ab-why-body-txt">{w.desc}</p>
                  </div>
                </li>
              ))}
            </ul>

            {/* "1 / 6 Title" counter */}
            {/* <div className="ab-why-counter">
              <span className="ab-why-counter-dot" />
              {activeIndex + 1}&nbsp;/&nbsp;{whyCards.length}&nbsp;—&nbsp;
              {whyCards[activeIndex].title}
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── CERTIFICATIONS ───────────────────────────────────────────
function Certifications() {
  const sectionRef = useRef(null);
  useSequentialReveal(sectionRef, ".cert-seq-card", 500);
  return (
    <section className="margin_top" ref={sectionRef}>
      <div className="container container_width">
        <div className="mb-5">
          <SectionLabel text="Recognition & Accreditation" />
          <h2 className="fw-semibold mb-3" style={{ fontSize: 20 }}>
            Recognised for Quality & Excellence
          </h2>
        </div>
        <div className="row g-4">
          {certs.map((c) => (
            <div key={c.title} className="col-md-6 col-lg-4 cert-seq-card">
              <div className="ab-cert-card card h-100 border-0 shadow-sm rounded-0 bg-white">
                <div className="card-body p-4">
                  <img
                    src={c.icon}
                    alt={c.title}
                    style={{
                      width: "44px",
                      height: "44px",
                      objectFit: "contain",
                    }}
                    className="d-block mb-3"
                  />
                  <p className="ab-cert-title text-dark small fw-bold text-uppercase mb-2">
                    {c.title}
                  </p>
                  <p className="content_text small mb-0">{c.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── Our Service Partner ─────────────────────────────────────────────────
function ServicePartners() {
  return (
    <section className="margin_top py-5 bg_color">
      <div className="container container_width">
        <div data-aos="fade-up">
          <SectionLabel text="Our Service Partners" />
          <h2 className="fw-semibold mb-5" style={{ fontSize: 20 }}>
            Trusted Industry Partners Supporting Our Services
          </h2>
        </div>
        <div className="container my-5">
          <div className="row justify-content-center g-4">
            {servicePartners.map((p, idx) => (
              <div
                className={`col-6 col-md-4 col-lg-2 ${idx >= 3 ? "mt-md-4" : ""}`}
                key={idx}
                data-aos="fade-down"
                data-aos-delay={idx * 300}
              >
                <div className="partner-card text-center p-3 h-100">
                  <div className="partner-img-box mb-2">
                    <img
                      src={p.image}
                      alt={p.name}
                      className="img-fluid partner-img"
                    />
                  </div>

                  <p className="partner-name">{p.name}</p>
                  <p className="partner-type">{p.type}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── CTA ──────────────────────────────────────────────────────
function CTA() {
  const navigate = useNavigate();

  return (
    <section className="ab-cta-section">
      <div
        className="ab-cta-wrap rounded-0 shadow-lg p-4 p-lg-5"
        style={{
          background: "linear-gradient(135deg, #cc0000 0%, #930000 100%)",
        }}
      >
        <div className="row g-4 align-items-center">
          <div className="col-lg-7 text-center text-lg-start">
            <h2 className="ab-cta-title display-4 fw-bolder text-white text-uppercase mb-3">
              Let's Build Something Great Together.
            </h2>
            <p className="content_text lead text-white opacity-75 mb-0">
              Whether you're looking to transform your business operations or
              launch a rewarding career —{" "}
              <span className="fw-bold"> Skimitar Hindusthan </span> is your
              trusted partner every step of the way.
            </p>
          </div>
          <div className="col-lg-5">
            <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-end">
              <button
                className="btn ab-btn-white px-4 py-3 fw-bold text-uppercase small"
                onClick={() => navigate("/contact")}
              >
                Get a Free Consultation
              </button>
              <button
                className="btn ab-btn-ghost px-4 py-3 fw-bold text-uppercase small"
                onClick={() => navigate("/corporatetrainings")}
              >
                Explore Training Programs
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── MAIN EXPORT ──────────────────────────────────────────────
export default function About() {
  const [meta, setMeta] = useState(null);

  // scroll top
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const fetchData = () => {
    const AboutMeta = data[0]?.about_page;
    if (AboutMeta) {
      setMeta(AboutMeta);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="about-page">
      <Helmet>
        <title>{meta ? meta.title : "About Us"}</title>
      </Helmet>
      <Hero />
      <StorySection />
      <MissionValues />
      {/* <Timeline /> */}
      <TeamSection />
      <WhyUs />
      <Certifications />
      {/* <Presence /> */}
      <ServicePartners />
      <CTA />
    </div>
  );
}
